
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sso-config",
      function () {
        return require("private-next-pages/sso-config.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sso-config"])
      });
    }
  